import React, { Fragment, useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import moment from "moment";
import {
  calendarlistmanager,
  crmprofileview,
} from "../../../services/cityregionaladmin";
import {
  fundergraphlist,
  fundermedalslist,
  schoolmanagerlist,
  statisticslist,
} from "../../../services/superadmin";
import { sportslist } from "../../../services/master";
import Select from "react-select";
import dotracking from "../../trackinglogs";
import trackobj from "../../trackingpages.json";
import { useNavigate } from "react-router-dom";
import { Bar, Line } from "react-chartjs-2";

export const CrmDashboard = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  const [slist, setSlist] = useState(0);
  const [flist, setFlist] = useState(0);
  const [glist, setGlist] = useState(0);
  const [stulist, setStulist] = useState(0);

  const [mlist, setMList] = useState([]);
  const [funid, setFunID] = useState("");
  const [splist, setSportList] = useState([]);
  const [tsport, setTSport] = useState(0);
  const [tyear, setTYear] = useState(0);
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;

  const [lchartData, setLChartData] = useState(null);
  const [bchartData, setBChartData] = useState(null);

  useEffect(() => {
    calendarlistmanager(localStorage.getItem("UID")).then((response) => {
      if (response.status === true) {
        let schedule = [];
        if (response.data.tournament_and_events.length !== 0) {
          for (let i = 0; i < response.data.tournament_and_events.length; i++) {
            var clr = "";
            var clink = "";
            const url = window.location.href;
            const head = url.split("/#/");
            if (response.data.tournament_and_events[i].type === "Tournament") {
              clr = "#005baa";
              clink =
                `${head[0]}/#/cityregional/tournamentdetail/` +
                response.data.tournament_and_events[i].id;
            } else if (
              response.data.tournament_and_events[i].type === "External" ||
              response.data.tournament_and_events[i].type === "External_1"
            ) {
              clr = "#c21a1a";
              clink =
                `${head[0]}/#/cityregional/externaltournamentdetail/` +
                response.data.tournament_and_events[i].id;
            } else {
              clr = "#e59216";
              clink =
                `${head[0]}/#/cityregional/othereventdetails/` +
                response.data.tournament_and_events[i].id;
            }
            schedule.push({
              title: response.data.tournament_and_events[i].meet_name,
              start: response.data.tournament_and_events[i].startdate,
              end: response.data.tournament_and_events[i].enddate,
              description: response.data.tournament_and_events[i].type,
              url: clink,
              color: clr,
            });
          }
          setEvents(schedule);
        }
      }
    });

    schoolmanagerlist(localStorage.getItem("UID")).then((response) => {
      if (response.status === true) {
        setSlist(response.data.school_list.length);
        setFlist(response.data.funder_list.length);
        setGlist(response.data.group_of_schools_list.length);
        setStulist(response.data.total_manager_students.length);
      }
    });

    sportslist().then((response) => {
      if (response.status === true) {
        if (response.data.length > 0) {
          let arr = [];
          for (let i = 0; i < response.data.length; i++) {
            arr.push({
              value: response.data[i].sports_cat_uid,
              label: response.data[i].sports_category,
            });
          }
          setSportList(arr);
        }
      }
    });

    const temp1 = new FormData();
    temp1.append("funder_id", localStorage.getItem("UID"));
    temp1.append("funder_or_manager", 2);
    fundergraphlist(temp1).then((res) => {
      if (res.status === true) {
        const apiData = res.data;
        const years = apiData.map((item) => item.year);

        const meetTypes = apiData[0].data.map((item) => item.meet_type);
        const datasets = meetTypes.map((meetType) => {
          const data = years.map((year) => {
            const yearData = apiData.find((item) => item.year === year);
            const meet = yearData
              ? yearData.data.find((m) => m.meet_type === meetType)
              : null;
            return meet ? meet.male_count + meet.female_count : 0;
          });

          return {
            label: meetType,
            data: data,
            backgroundColor: meetTypeColors[meetType] || "#cccccc",
          };
        });

        const ldatasets = meetTypes.map((meetType) => {
          const data = years.map((year) => {
            const yearData = apiData.find((item) => item.year === year);
            const meet = yearData
              ? yearData.data.find((m) => m.meet_type === meetType)
              : null;
            return meet ? meet.male_count + meet.female_count : 0;
          });

          return {
            label: meetType,
            data: data,
            borderColor: meetTypeColors[meetType] || "#cccccc",
            tension: 0.4,
            fill: false,
          };
        });
        setLChartData({
          labels: years,
          datasets: ldatasets,
        });
      }
    });

    // crmprofileview().then((response) => {
    //   if (response.status === true) {
    //     setFunID(response.data.id);
    listall(0, 0);
    //   }
    // });
  }, []);
  const openModal = (event) => {
    setSelectedEvent(event);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedEvent("");
    setModalIsOpen(false);
  };

  const handleEventClick = (info) => {
    const clickedEvent = {
      title: info.event.title,
      start: info.event.startStr,
      end: info.event.endStr,
      description: info.event.description,
      sports: info.event.sports,
      event: info.event.event,
    };
    openModal(clickedEvent);
  };

  function handleSport(e) {
    if (e !== null) {
      setTSport(e);
      listall(e, tyear);
    } else {
      setTSport(0);
      listall(0, tyear);
    }
  }
  const [opts, setOpts] = useState({});
  function listall(spid, fyear) {
    setMList([]);
    setTYear(fyear);
    const temp = new FormData();
    temp.append("year", fyear);
    if (spid !== 0) {
      temp.append("sports", spid.value);
    } else {
      temp.append("sports", "");
    }
    temp.append("funder_id", localStorage.getItem("UID"));
    temp.append("funder_or_manager", 2);

    statisticslist(temp).then((res) => {
      if (res.status === true) {
        setMList(res.data);
      }
    });

    fundermedalslist(temp).then((res) => {
      if (res.status === true) {
        // setMList(res.data);

        const summedData = {
          International: {
            maleAge8AndFemaleAge8: [],
            maleAge8_14AndFemaleAge8_14: [],
            maleAge15_18AndFemaleAge15_18: [],
            maleAge18PlusAndFemaleAge18Plus: [],
          },
          National: {
            maleAge8AndFemaleAge8: [],
            maleAge8_14AndFemaleAge8_14: [],
            maleAge15_18AndFemaleAge15_18: [],
            maleAge18PlusAndFemaleAge18Plus: [],
          },
          State: {
            maleAge8AndFemaleAge8: [],
            maleAge8_14AndFemaleAge8_14: [],
            maleAge15_18AndFemaleAge15_18: [],
            maleAge18PlusAndFemaleAge18Plus: [],
          },
          Zonal: {
            maleAge8AndFemaleAge8: [],
            maleAge8_14AndFemaleAge8_14: [],
            maleAge15_18AndFemaleAge15_18: [],
            maleAge18PlusAndFemaleAge18Plus: [],
          },
          District: {
            maleAge8AndFemaleAge8: [],
            maleAge8_14AndFemaleAge8_14: [],
            maleAge15_18AndFemaleAge15_18: [],
            maleAge18PlusAndFemaleAge18Plus: [],
          },
          "Inter-School": {
            maleAge8AndFemaleAge8: [],
            maleAge8_14AndFemaleAge8_14: [],
            maleAge15_18AndFemaleAge15_18: [],
            maleAge18PlusAndFemaleAge18Plus: [],
          },
          "Intra-School": {
            maleAge8AndFemaleAge8: [],
            maleAge8_14AndFemaleAge8_14: [],
            maleAge15_18AndFemaleAge15_18: [],
            maleAge18PlusAndFemaleAge18Plus: [],
          },
        };

        res.data.forEach((item) => {
          const meetType = item.meet_type;

          if (summedData[meetType]) {
            summedData[meetType].maleAge8AndFemaleAge8 +=
              item.male_age_8 + item.female_age_8;
            summedData[meetType].maleAge8_14AndFemaleAge8_14 +=
              item.male_age_8_14 + item.female_age_8_14;
            summedData[meetType].maleAge15_18AndFemaleAge15_18 +=
              item.male_age_15_18 + item.female_age_15_18;
            summedData[meetType].maleAge18PlusAndFemaleAge18Plus +=
              item.male_age_18_plus + item.female_age_18_plus;
          }
        });

        // const years = ["<8 Years", "8-14 Years", "15-18 Years", ">18 Years"];
        // const pdata = {
        //   labels: years,
        //   datasets: Object.keys(summedData).map((meetType) => {
        //     return {
        //       label: meetType,
        //       data: [
        //         summedData[meetType].maleAge8AndFemaleAge8,
        //         summedData[meetType].maleAge8_14AndFemaleAge8_14,
        //         summedData[meetType].maleAge15_18AndFemaleAge15_18,
        //         summedData[meetType].maleAge18PlusAndFemaleAge18Plus,
        //       ],
        //       backgroundColor: meetTypeColors[meetType] || "#cccccc",
        //     };
        //   }),
        // };
        const years = res.data.map((item) => item.meet_type);
        const maleCounts = res.data.map((item) => item.male_count);
        const femaleCounts = res.data.map((item) => item.female_count);
        const pdata = {
          labels: years,
          datasets: [
            {
              label: "Male",
              data: maleCounts,
              backgroundColor: "#25e3da",
            },
            {
              label: "Female",
              data: femaleCounts,
              backgroundColor: "#f74dc1",
            },
          ],
        };
        setBChartData(pdata);
      }
    });

    if (window.innerWidth < 768) {
      const odata = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            //   text: 'ABC',
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "",
            },
          },
          y: {
            title: {
              display: true,
              text: "",
            },
          },
        },
      };
      setOpts(odata);
    } else {
      const odata = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            //   text: 'ABC',
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "",
            },
          },
          y: {
            title: {
              display: true,
              text: "",
            },
          },
        },
      };
      setOpts(odata);
    }
  }

  const meetTypeColors = {
    International: "#25e3da", // Cyan
    National: "#2977ff", // Blue
    State: "#f74dc1", // Pink
    Zonal: "#83efbe", // Light Green
    District: "#cb83ef", // Purple
    "Inter-School": "#e8f167", // Yellow
    "Intra-School": "#f1ae67", // Orange
  };

  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">Dashboard</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Home</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Dashboard
            </li>
          </ol>
        </div>

        <div className="row row-cards">
          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-teal">
                  <i className="fa fa-bank text-white-1 text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Total Schools</p>
                <p className="h3 text-center text-teal">{slist}</p>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-primary">
                  <i className="icon-organization text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Total Funder</p>
                <p className="h3 text-center text-primary-1">{flist}</p>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg icons shadow-default bg-purple">
                  <i className="icon-event text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Total Group of Schools</p>
                <p className="h3 text-center text-purple">{glist}</p>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-info">
                  <i className="icon-people text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Total Students</p>
                <p className="h3 text-center text-info">{stulist}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="ag_courses_head">
          <h4>Players Statistics</h4>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">Sports</label>
            <Select
              className="dropdown"
              placeholder="Select Sports"
              value={tsport}
              options={splist}
              onChange={handleSport}
              isSearchable={true}
              isClearable
              hidden
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Financial Year</label>

            <select
              className="form-control"
              value={tyear}
              onChange={(e) => listall(tsport, e.target.value)}
            >
              <option value={0}>All</option>
              <option value={currentYear}>Current Year</option>
              <option value={lastYear}>Last Year</option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="col-md-5">
            <div className="table-responsive">
              <table className="sp-league-table sp-data-table">
                <thead className="sp-table-header">
                  <tr role="row">
                    <th className="text-center">Players</th>
                    <th className="text-center">Male</th>
                    <th className="text-center">Female</th>
                    <th className="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {mlist.map((item, j) => {
                    const getRowColor = () => {
                      return j % 2 === 0 ? "even" : "odd";
                    };
                    return (
                      <>
                        <tr
                          className={`sp-row-no-0 ${getRowColor()}`}
                          role="row"
                          key={j}
                          onClick={() => {
                            localStorage.getItem("Page", 1);
                            dotracking(
                              "view individual list of tournament type in dashboard for " +
                                item.meet_type +
                                " $$ " +
                                trackobj.achievelistheading
                            );
                            navigate(
                              "/cityregional/individualachievementlist/" +
                                item.meet_type
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="data-pct">{item.meet_type}</td>
                          <td className="data-pct">{item.male_count}</td>
                          <td className="data-pct">{item.female_count}</td>
                          <td className="data-pct">
                            {item.male_count + item.female_count}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-7">
            <div className="table-responsive">
              <table className="sp-league-table sp-data-table">
                <thead className="sp-table-header">
                  <tr role="row">
                    <th className="text-center">Players</th>
                    <th className="text-center">&lt;8 Years</th>
                    <th className="text-center">8-14 Years</th>
                    <th className="text-center">15-18 Years</th>
                    <th className="text-center">&gt;18 Years</th>
                    <th className="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {mlist.map((item, j) => {
                    const getRowColor = () => {
                      return j % 2 === 0 ? "even" : "odd";
                    };
                    return (
                      <>
                        <tr
                          className={`sp-row-no-0 ${getRowColor()}`}
                          role="row"
                          key={j}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            localStorage.getItem("Page", 1);
                            dotracking(
                              "view individual list of tournament type in dashboard for " +
                                item.meet_type +
                                " $$ " +
                                trackobj.achievelistheading
                            );
                            navigate(
                              "/cityregional/individualachievementlist/" +
                                item.meet_type
                            );
                          }}
                        >
                          <td className="data-pct">{item.meet_type}</td>
                          <td className="data-pct">
                            {item.female_age_8 + item.male_age_8}
                          </td>
                          <td className="data-pct">
                            {item.female_age_8_14 + item.male_age_8_14}
                          </td>
                          <td className="data-pct">
                            {item.female_age_15_18 + item.male_age_15_18}
                          </td>
                          <td className="data-pct">
                            {item.female_age_18_plus + item.male_age_18_plus}
                          </td>

                          <td className="data-pct">
                            {item.female_age_8 +
                              item.male_age_8 +
                              item.female_age_8_14 +
                              item.male_age_8_14 +
                              item.female_age_15_18 +
                              item.male_age_15_18 +
                              item.female_age_18_plus +
                              item.male_age_18_plus}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="ag_courses_head mt-2">
          <h4>Participation Statistics</h4>
        </div>
        <div className="col-md-12">
          <div id="chart-container">
            {bchartData && bchartData.labels && bchartData.datasets && (
              <Bar data={bchartData} options={opts} />
            )}
          </div>

          <div id="chart-container">
            {lchartData && lchartData.labels && lchartData.datasets && (
              <Line data={lchartData} options={opts} />
            )}
          </div>
        </div>
        <hr />

        <div className="row">
          <div className="ag_courses_head">
            <h4>Tournament & Events Calender</h4>
          </div>
          <div className="col-12">
            <div className="card mt-0">
              <div className="card-body">
                <FullCalendar
                  plugins={[dayGridPlugin]}
                  initialView="dayGridMonth"
                  events={events}
                  eventClick={handleEventClick}
                />

                <Modal show={modalIsOpen} size="xl">
                  <Modal.Header>
                    <Modal.Title>Tournament & Events Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="table-responsive">
                      <table className="sp-league-table sp-data-table">
                        <thead className="sp-table-header">
                          <tr role="row">
                            <th className="text-center">Title</th>
                            <th className="text-center">Start Date</th>
                            <th className="text-center">End Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="sp-row-no-0 even" role="row">
                            <td class="data-pct">{selectedEvent.title}</td>
                            <td class="data-pct">
                              {moment(selectedEvent.start).format("DD-MM-YYYY")}
                            </td>
                            {selectedEvent.end !== "" && (
                              <td className="data-pct">
                                {moment(selectedEvent.end).format("DD-MM-YYYY")}
                              </td>
                            )}
                            {selectedEvent.end === "" && (
                              <td className="data-pct">
                                {moment(selectedEvent.start).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <a className="btn btn-gray" onClick={closeModal}>
                      Close
                    </a>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
